export type CommandCenterTeamAssignment = {
  team_id: string;
  assignment_role: string;
  is_active: boolean;
  deleted_at?: string | null;
};

/**
 * Default captain workflows use responsibility, not the general access list.
 * Only explicit, current Captain and Co-Captain assignments qualify a team.
 */
export function defaultCaptainTeamIds(
  assignments: CommandCenterTeamAssignment[],
  activeTeamIds: string[],
): string[] {
  const active = new Set(activeTeamIds);
  return [...new Set(
    assignments
      .filter((assignment) => assignment.is_active && !assignment.deleted_at)
      .filter((assignment) => assignment.assignment_role === 'captain' || assignment.assignment_role === 'co_captain')
      .map((assignment) => assignment.team_id)
      .filter((teamId) => active.has(teamId)),
  )];
}

// Keep the original name for existing Command Center consumers.
export const responsibleCommandCenterTeamIds = defaultCaptainTeamIds;
